//utils
require('./utils/jquery');
require('./utils/axios');
require('./utils/cookieconsent');
require('./utils/easymde');
require('./utils/sweetalert');
require('./utils/sumoselect');
require('./utils/lity');
require('./utils/moment');
require('./utils/air-datepicker');
// bootstrap
require('bootstrap');
require('./bootstrap/file-input');
require('./bootstrap/modal');
require('./bootstrap/nav');
// custom
require('./custom/new-window');
require('./custom/data-confirm');
require('./custom/no-click');
require('./custom/back-top');

if (! window.hasOwnProperty('global')) {
    window.global = {};
}
window.global.width = $(window).width();

$(window).resize(() => {
    window.global.width = $(window).width();
});